import { z } from "zod";
import { dateSchema } from "./schemasComplex";

export const schemaFormExtraction = z
  .object({
    dateFrom: dateSchema,
    dateTo: dateSchema,
    format: z.enum(["csv", "pdf"], {
      required_error: "SÃ©lectionnez un format",
    }),
  })
  .refine(
    (data) =>
      data.dateTo.isAfter(data.dateFrom) ||
      data.dateTo.isSame(data.dateFrom, "day"),
    {
      message:
        "La date de fin doit Ãªtre postÃ©rieure ou Ã©gale Ã  la date de dÃ©but",
      path: ["dateTo"],
    },
  );

export type SchemaFormExtraction = z.infer<typeof schemaFormExtraction>;
